"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentFieldDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const content_field_json_1 = require("./content-field-json");
exports.ContentFieldDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('ContentModel', content_field_json_1.ContentFieldJsonMapper);
